import { useEffect, useRef, useState } from 'react'

/**
 * Оверлей «стекло-капля» для плитки карточки (tile_style = 'droplet').
 *
 * Рендерится ВНУТРИ корня плитки (у корня должен стоять класс
 * `glass-droplet-host` — наружная тень-капля) и рисует стеклянную кромку
 * с рефракцией + блик-фаску (см. _glass-droplet.scss). Радиус наследуется.
 *
 * Перф-гейт: рефракция (backdrop-filter c SVG-displacement) дорогая — класс
 * `is-live` ставится только пока плитка видна во вьюпорте; за экраном слой
 * инертен (маска и блик без фильтра ничего не стоят).
 */
export default function DropletGlass() {
	const ref = useRef<HTMLSpanElement>(null)
	const [live, setLive] = useState(false)

	useEffect(() => {
		const el = ref.current
		if (!el || typeof IntersectionObserver === 'undefined') {
			// Нет observer'а (старый WebView) — включаем без гейта, колбэком
			// (setState в теле эффекта запрещён линтом set-state-in-effect).
			const t = window.setTimeout(() => setLive(true), 0)
			return () => window.clearTimeout(t)
		}
		const io = new IntersectionObserver(
			(entries) => setLive(entries.some((e) => e.isIntersecting)),
			// Запас 25%: эффект включается чуть до появления — без «проявления
			// стекла» на глазах при быстром скролле.
			{ rootMargin: '25%' },
		)
		io.observe(el)
		return () => io.disconnect()
	}, [])

	return (
		<span ref={ref} className={`glass-droplet${live ? ' is-live' : ''}`} aria-hidden="true">
			<span className="glass-droplet__edge" />
			<span className="glass-droplet__shine" />
		</span>
	)
}
